<script lang="ts" setup>
defineOptions({
  name: 'LayoutDefault',
})

</script>

<template>
  <main class="cs-auth">
    <slot />
  </main>
</template>
